import { API, IdUser } from "./apiConfig";
import { API_Account } from "./schema/API_Account";

// get all order online
export const getAllOderOnline = (PageNumber, search) => {
  const data = {
    IdUser,
    PageNumber,
    search,
  };
  return API.post("/UnitAccounting/AllOrderOnline", data);
};

// get all not approver order online
export const getApprovedOnlinOrder = (PageNumber) => {
  const data = {
    IdUser,
    PageNumber,
  };
  return API.post("/UnitAccounting/NotApprovedOrderOnline", data);
};

// get all not payment order online
export const getNotPaymentOrderOnline = (PageNumber) => {
  const data = {
    IdUser,
    PageNumber,
  };
  return API.post("/UnitAccounting/NotPaymentOrderOnline", data);
};

// get to deliver order online
export const getDeliverOrderOnline = (PageNumber) => {
  const data = {
    IdUser,
    PageNumber,
  };
  return API.post("/UnitAccounting/ToDelivererOrderOnline", data);
};

// get not ok custmer order online
export const getNotOkCustomerOrderOnline = (PageNumber) => {
  const data = {
    IdUser,
    PageNumber,
  };
  return API.post("/UnitAccounting/NotOkCustomerOrderOnline", data);
};

// get ok customer order online
export const getOkCustomerOrderOnline = (PageNumber) => {
  const data = {
    IdUser,
    PageNumber,
  };
  return API.post("/UnitAccounting/OkCustomerOrderOnline", data);
};

// -------------------------------detail order--------------------------------
export const getDetailOderOnline = (idOrderOnline) => {
  const data = {
    IdUser,
    IdOrderOnline: idOrderOnline,
  };
  return API.post("/UnitAccounting/DetailOrderOnline", data);
};

// ChangeStatusOrderOnlineOkAndPay
export const changeStatusOrderOnlineOkPay = (idOrderOnline) => {
  const data = {
    IdUser,
    IdOrderOnline: idOrderOnline,
  };
  return API.post("/UnitAccounting/ChangeStatusOrderOnlineOkAndPay", data);
};

// ChangeStatusOrderOnlineComplete
export const changeStatusOrderOnlineComplete = (idOrderOnline) => {
  const data = {
    IdUser,
    IdOrderOnline: idOrderOnline,
  };
  return API.post("/UnitAccounting/ChangeStatusOrderOnlineComplete", data);
};

// ChangeStatusOrderOnlineActive
export const changeStatusOrderOnlineActive = (idOrderOnline) => {
  const data = {
    IdUser,
    IdOrderOnline: idOrderOnline,
  };
  return API.post("/UnitAccounting/ChangeStatusOrderOnlineActive", data);
};

// UpdateDetailOrderOnlineNumberProduct
export const updateDetailOnlineNumberProduct = (orderData) => {
  const data = {
    ...orderData,
    IdUser,
  };
  return API.post("/UnitAccounting/UpdateDetailOrderOnlineNumberProduct", data);
};

// getting the image list
export const productOrderOnline = () => {
  const data = {
    IdUser,
  };
  return API.post("/UnitAccounting/ProductOrderOnline", data);
};

// InsertDetailOrderOnlineNumberProduct

export const insertDetailOrderOnlineNumberProduct = (productData) => {
  const data = {
    IdUser,
    ...productData,
  };
  return API.post("/UnitAccounting/InsertDetailOrderOnlineNumberProduct", data);
};

// DeleteDetailOrderOnline
export const deleteDetailOrderOnline = (id) => {
  const data = {
    IdListOrderOnline: id,
    IdUser,
  };
  return API.post("/UnitAccounting/DeleteDetailOrderOnline", data);
};

// DeleteOneOrderOnline
export const deleteOneOrderOnline = (id) => {
  const data = {
    IdOrderOnline: id,
    IdUser,
  };
  return API.post("/UnitAccounting/DeleteOneOrderOnline", data);
};

// ListAllUser
export const listUser = (PageNumber) =>
  API.post("/UnitManagement/AllUser/ListAllUser", PageNumber);

// detail a user
export const geDetailUser = (IdPerson) => {
  const data = {
    IdUser,
    IdPerson,
  };
  return API.post("/UnitAccounting/BasicOperations/UserTurnover", data);
};

// add new user
export const addNewUser = (userData) => {
  const data = {
    ...userData,
    IdUser,
  };
  return API.post("/UnitManagement/AllUser/InsertUser", data);
};

// update user
export const updatedUser = (userData) => {
  const data = {
    ...userData,
    IdUser,
  };
  return API.post("/UnitManagement/AllUser/UpdatePerson", data);
};

// delete user
export const deleteUser = (IdPerson) => {
  const data = {
    IdPerson,
    IdUser,
  };
  return API.post("/UnitManagement/AllUser/DeletePerson", data);
};

// --------------------------Order Offline-----------------

// InsertOrderOffline
export const addOrderOffline = (orderOfflineData) => {
  const data = {
    ...orderOfflineData,
    IdUser,
  };

  return API.post("/UnitAccounting/OrderOffline/InsertOrderOffline", data);
};

// delete order offline
export const deleteOrderOnline = (orderOfflineData) => {
  const data = {
    ...orderOfflineData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/DeleteListOrderOffline", data);
};

// update order offline
export const updatedOrderOffline = (orderOfflineData) => {
  const data = {
    ...orderOfflineData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/UpdateListOrderOffline", data);
};

// get order offline
export const getAllOrderOffline = (IdEquivalentOrderOffline) => {
  const data = {
    ...IdEquivalentOrderOffline,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/ShowListOrderOffline", data);
};

// final confirm api
export const finalConfirm = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };

  return API.post("UnitAccounting/OrderOffline/InsertPreInvoice", data);
};

// get final print
export const getFinalPrint = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/PrintPreInvoice", data);
};

// get final print
export const getFactor = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/PrintFactor", data);
};

export const getCheckUpdate = (ReferralId) => {
  const data = {
    ReferralId,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/ShowChecksForUpdateResiveOperation",
    data
  );
};

export const deleteCheckPaymentSell = (IdFactorStatusPayments) => {
  const data = {
    IdFactorStatusPayments,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/DeleteResiveOperation",
    data
  );
};

export const updateNaghdiCheck = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/UpdateResiveOperation",
    data
  );
};

export const updateHavaleCheck = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };

  return API.post(
    "/UnitAccounting/BasicOperations/UpdateResiveOperation",
    data
  );
};

// -----------------------------ListPreInvoice-------------------------
// get preInvoice
export const getListPreInvoice = (PageNumber) => {
  const data = {
    PageNumber,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/ListPreInvoice", data);
};

// delete a preInvoice
export const deletePreInvoice = (IdEquivalentOrderOffline) => {
  const data = {
    IdUser,
    IdEquivalentOrderOffline,
  };
  return API.post("/UnitAccounting/OrderOffline/DeletePreInvoice", data);
};

// ConversionToFactor
export const conversionToFactor = (IdEquivalentOrderOffline) => {
  const data = {
    IdEquivalentOrderOffline,
    IdUser,
  };

  return API.post("/UnitAccounting/OrderOffline/ConversionToFactor", data);
};

// search in preInvoice
export const searchPreInvoice = (searchData) => {
  const data = {
    ...searchData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/SearchListPreInvoice", data);
};

// ----------------------------------Check Service-----------------------------
// get all checks
export const getAllCheckList = () => {
  const data = {
    IdUser,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/ShowCashChecksFirstPeriod",
    data
  );
};
// get available check
export const getAvaiableCheck = () => {
  const data = {
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/ShowCashChecksFactor", data);
};

// get all of the checks
export const getAllOfChecks = () => {
  const data = {
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/ShowCashChecks", data);
};

// add new check
export const addNewCheck = (checkDate) => {
  const data = {
    ...checkDate,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/InsertCashChecks", data);
};

// update check
export const updateCheck = (checkDate) => {
  const data = {
    ...checkDate,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/UpdateCashChecks", data);
};

// delete a check
export const deleteCheck = (IdCashChecks) => {
  const data = {
    IdCashChecks,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/DeleteCashChecks", data);
};

export const getBackCheck = () => {
  const data = {
    IdUser,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/ShowCashChecksPayment",
    data
  );
};

export const addNewCheckBack = (checkData) => {
  const data = {
    IdUser,
    ...checkData,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/InsertCashChecksPayment",
    data
  );
};

// --------------------------------Factor Service -------------------------------
// ListDocumentToFactor
export const getListDocumentFactor = (IdEquivalentOrder) => {
  const data = {
    IdEquivalentOrder,
    IdUser,
  };

  return API.post("/UnitAccounting/OrderOffline/ListDocumentToFactor", data);
};

// add naghdi factor
export const addNaghdiFactor = (naghdiData) => {
  const data = {
    ...naghdiData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/InsertDocumentToFactor", data);
};

// update naghdi factor
export const updateNaghdiFactor = (naghdiData) => {
  const data = {
    ...naghdiData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/UpdateDocumentToFactor", data);
};

// confirmFactor
export const confirmFactor = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/InsertFactor", data);
};

// add check factor
export const addCheckFactor = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/InsertDocumentToFactor", data);
};

// update check factor
export const updateCheckFactor = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/UpdateDocumentToFactor", data);
};

// delete sanad daryaft
export const deleteSandadDaryaft = (IdFactorStatusPayments) => {
  const data = {
    IdFactorStatusPayments,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/DeleteDocumentToFactor", data);
};

// get all list of factor
export const getAllFactor = (PageNumber) => {
  const date = {
    PageNumber,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/ListFactor", date);
};

export const updateHavale = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/UpdateDocumentToFactor", data);
};

export const updateCardkhan = (havaleData) => {
  const data = {
    ...havaleData,
    IdUser,
  };
  return API.post("/UnitAccounting/OrderOffline/UpdateDocumentToFactor", data);
};
// -----------------------------anbar service----------------------------
// get list anbar
export const getListAnbar = () => {
  const data = {
    IdUser,
  };
  return API.post("/UnitManagement/AllUser/ListWarehouseTypes", data);
};

// add new anbar
export const addNewAnbar = (anbarData) => {
  const data = {
    ...anbarData,
    IdUser,
  };
  return API.post("/UnitManagement/AllUser/InsertWarehouseTypes", data);
};

// update anbar
export const updateAnbar = (anbarData) => {
  const data = {
    ...anbarData,
    IdUser,
  };
  return API.post("/UnitManagement/AllUser/UpdateWarehouseTypes", data);
};

// delete anbar
export const deleteAnbar = (IdWarehouseTypes) => {
  const data = {
    IdWarehouseTypes,
    IdUser,
  };
  return API.post("/UnitManagement/AllUser/DeleteWarehouseTypes", data);
};
// -----------------------------cost service----------------------------

// add new cost
export const addCost = (costData) => {
  const data = {
    ...costData,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/InsertCosts", data);
};
// get all cost
export const getAllCost = () => {
  const data = {
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/ListCosts", data);
};

// delete a cost
export const deleteCost = (IdCosts) => {
  const data = {
    IdCosts,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/DeleteCosts", data);
};
// update a cost
export const updateCost = (costData) => {
  const data = {
    ...costData,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/UpdateCosts", data);
};
// --------------------------income service---------------------------
// get all list income
export const getAllIcomeList = () => {
  const data = {
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/ListRevenues", data);
};

// add new income
export const addNewIncome = (incomeData) => {
  const data = {
    ...incomeData,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/InsertRevenues", data);
};

// delete a income
export const deleteIncome = (IdRevenues) => {
  const data = {
    IdRevenues,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/DeleteRevenues", data);
};
// update a income
export const updateIncome = (updateData) => {
  const data = {
    ...updateData,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/UpdateRevenues", data);
};

// -------------------service return sales----------------------

// get list order offline and order onlines
export const getListOrderOfflinesAndListOrderOnlines = (IdPerson) => {
  const data = {
    IdPerson,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/ReturnOnSales/ListOrderOfflineAndListOrderOnlines",
    data
  );
};
// insert return in sale
export const returnOnSale = (saleData) => {
  const data = {
    ...saleData,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/ReturnOnSales/InsertReturnOnSalesController",
    data
  );
};

// ShowListReturnOnSalesDetail
export const getListReturnOnSale = (IdEquivalentReturnOnSales) => {
  const data = {
    IdEquivalentReturnOnSales,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/ReturnOnSales/ShowListReturnOnSalesDetail",
    data
  );
};

// delete return on sale
export const deleteOrderReturnOnSale = (dataOrder) => {
  const data = {
    ...dataOrder,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/ReturnOnSales/DeleteReturnOnSalesDetail",
    data
  );
};

// Confirm UnitAccounting/ReturnOnSales/InsertReturnOnSales
export const confirmReturnOnSale = (dataOrder) => {
  const data = {
    ...dataOrder,
    IdUser,
  };
  return API.post("/UnitAccounting/ReturnOnSales/InsertReturnOnSales", data);
};

// edit /UnitAccounting/ReturnOnSales/UpdateListReturnOnSalesDetail
export const editReturnOnSale = (orderData) => {
  const data = {
    ...orderData,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/ReturnOnSales/UpdateListReturnOnSalesDetail",
    data
  );
};

// get list return on sale
export const listReturnOnSale = () => {
  const data = {
    IdUser,
  };
  return API.post("/UnitAccounting/ReturnOnSales/ShowListReturnOnSales", data);
};

export const getListRecieveChecklist = () => {
  const data = {
    IdUser,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/ShowFirstPeriodReceiveCheckList",
    data
  );
};

export const getListPaymentChecklist = () => {
  const data = {
    IdUser,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/ShowFirstPeriodPaymentCheckList",
    data
  );
};

export const changeCheckStatus = (checkData) => {
  const data = {
    ...checkData,
    IdUser,
  };
  return API.post("/UnitAccounting/BasicOperations/ChangeCheckStatus", data);
};

// -----------------------Purchase Incoice-----------------------------
export const getSupplierList = () =>
  API.get(API_Account.purchaseInvoice.GET_SUPPLIRE_LIST);

export const addFactorPurchaseCustom = (factorInfo) => {
  const data = {
    ...factorInfo,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.ADD_FACTOR_PURCHASE_CUSTOM, data);
};

export const getListPurchaceFactorCustom = (IdEquivalentFactorBuys) => {
  const data = {
    IdEquivalentFactorBuys,
    IdUser,
  };
  return API.post(
    API_Account.purchaseInvoice.GET_LIST_PURCHASE_FACTOR_CUSTOM,
    data
  );
};

export const getCashDetail = (cashId) => {
  return API.post(API_Account.basicOperations.GET_CASH_DETAIL, {
    ...cashId,
    IdUser,
  });
};

export const getBankDetail = (bankId) => {
  return API.post(API_Account.basicOperations.GET_BANK_DETAIL, {
    ...bankId,
    IdUser,
  });
};

export const getCheckDetail = () => {
  return API.post(API_Account.basicOperations.GET_CHECK_DETAIL, {
    IdUser,
  });
};

export const getCheckPaidDetail = () => {
  return API.post(API_Account.basicOperations.GET_CHECK_RECEIVED_DETAIL, {
    IdUser,
  });
};

export const addNaghdiFactorPurchase = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.ADD_NAGHDI_FACTOR_PURCHASE, data);
};

export const addHavaleFactorPurchase = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.ADD_HAVALE_FACTOR_PURCHASE, data);
};

export const addCartkhanFactorPurchase = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(
    API_Account.purchaseInvoice.ADD_CARTKHAN_FACTOR_PURCHASE,
    data
  );
};

export const addCheckFactorPurchase = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.ADD_CHECK_FACTOR_PURCHASE, data);
};

export const getListPurchase = (IdEquivalentSell) => {
  const data = {
    IdEquivalentSell,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.GET_LIST_PURCHASE, data);
};

export const finalConformPurchaseCutom = (IdEquivalentFactorBuys) => {
  const data = {
    IdEquivalentFactorBuys,
    IdUser,
  };
  return API.post(
    API_Account.purchaseInvoice.FINAL_CONFIRM_PURCHASE_CUSTOM,
    data
  );
};

export const updatePurchasenaghdi = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(
    API_Account.purchaseInvoice.UPDATE_FACTOR_PURCHASE_NAGHDI,
    data
  );
};

export const updatePurchaseCheck = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.UPDATE_PURCHASE_CHECK, data);
};

export const getListFactorPurchase = () => {
  const data = {
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.GET_LIST_FACTOR_PURCHASE, data);
};

export const deletePurchaseProduct = (IdListFactorBuys) => {
  const data = {
    IdListFactorBuys,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.DELETE_PURCHACE_PRODUCT, data);
};

export const updatePurchaseProduct = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.UPDATE_PURCHASE_PRODUCT, data);
};

// -------------------------Operation Sell ----------------------
export const getListSellPayment = (PageNumber) => {
  const data = {
    PageNumber,
    IdUser,
  };
  return API.post(API_Account.paymentSell.GET_LIST_PAYMENT_SELL, data);
};

export const getListOperation = (PageNumber) => {
  const data = {
    PageNumber,
    IdUser,
  };
  return API.post(API_Account.paymentSell.GET_LIST_PAYMENT_OPERATION, data);
};

export const addCheckPaymentSell = (checkData) => {
  const data = {
    ...checkData,
    IdUser,
  };
  return API.post(API_Account.paymentSell.ADD_CHECK_PAYEMENT_SELL, data);
};

export const updateCheckSell = (checkData) => {
  const data = {
    ...checkData,
    IdUser,
  };
  return API.post(API_Account.paymentSell.UPDATE_CHECK_SELL, data);
};

export const updatePurchaseCartkhan = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.UPDATE_PURCHASE_CARTKHAN, data);
};

export const updatePurchaseHavale = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.UPDATE_PURCHASE_HAVALE, data);
};

export const deletePurchaseItem = (IdPaymentOperations) => {
  const data = {
    IdPaymentOperations,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.DELETE_PURCHASE_ITEM, data);
};

export const getResponeCheck = (ReferralId) => {
  const data = {
    ReferralId,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.GET_RESPONSE_CHECK, data);
};

// ----------------------------payment operation -----------------------
export const addCheckPaymentOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(
    API_Account.paymentOperation.ADD_CHECK_PAYMENT_OPERATION,
    data
  );
};

export const addNaghdiPaymentOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(
    API_Account.paymentOperation.ADD_NAGHDI_PAYMENT_OPERATION,
    data
  );
};

export const addCartkhanPaymentOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(
    API_Account.paymentOperation.ADD_CARTKHAN_PAYMENT_OPERATION,
    data
  );
};

export const addHavalePaymentOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(
    API_Account.paymentOperation.ADD_HAVALE_PAYMENT_OPERATION,
    data
  );
};

export const getListPaymentOperation = (IdUserForPaymentOperation) => {
  const data = {
    IdUserForPaymentOperation,
    IdUser,
  };
  return API.post(
    API_Account.paymentOperation.GET_LIST_PAYMENT_OPERAITION,
    data
  );
};

export const deletePaymentItemOperation = (IdPaymentOperations) => {
  const data = {
    IdPaymentOperations,
    IdUser,
  };
  return API.post(
    API_Account.paymentOperation.DELETE_ITEM_PAYMENT_OPERATION,
    data
  );
};

export const addFactorAutoPurchase = (IdSupplier) => {
  const data = {
    IdSupplier,
    IdUser,
  };
  return API.post(API_Account.purchaseInvoice.ADD_FACTOR_AUTO_PURCHASE, data);
};

export const updateNaghdiPaymentOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(
    API_Account.paymentOperation.UPDATE_NAGHDI_PAYMENT_OPERATION,
    data
  );
};

export const updateCartkhabPaymentSell = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.recieveOperation.UPDATE_RECIEVE_OPERATION, data);
};

// recieve operation
export const recieveOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.recieveOperation.ADD_FACTOR_NAGHDI, data);
};

export const detailRecieveOperation = (IdUserForResiveOperation) => {
  const data = {
    IdUserForResiveOperation,
    IdUser,
  };
  return API.post(
    API_Account.recieveOperation.GET_DETAIL_RECIEVE_OPERATION,
    data
  );
};

export const addCheckRecieveOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.recieveOperation.ADD_FACTOR_CHECK, data);
};

export const addHavaleRecieveOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.recieveOperation.ADD_FACTOR_HAVALE, data);
};

export const addCartkhanRecieveOperation = (factorData) => {
  const data = {
    ...factorData,
    IdUser,
  };
  return API.post(API_Account.recieveOperation.ADD_FACTOR_CARTKHAN, data);
};

export const deleteFactorItemRecievePayment = (IdFactorStatusPayments) => {
  const data = {
    IdFactorStatusPayments,
    IdUser,
  };
  return API.post(
    "/UnitAccounting/BasicOperations/DeleteResiveOperation",
    data
  );
};

export const getDashboard = () => {
  return API.post("UnitAccounting/Dashboard", {
    IdUser,
  });
};

// -----------------------Havale Hessab----------------------
export const getListHavaleHesab = () => {
  const data = {
    IdUser,
  };
  return API.post(API_Account.haveleHesab.GET_LIST_HAVALE_HESAB, data);
};

export const getAccessHavaleStatus = () => {
  const data = {
    IdUser,
  };
  return API.post(API_Account.haveleHesab.GET_ACCESS_HAVALE_HESAB_STATUS, data);
};

export const addHavaleHesab = (formData) => {
  const data = {
    ...formData,
    IdUser,
  };
  return API.post(API_Account.haveleHesab.ADD_HAVALE_HESAB, data);
};

export const nonPortalPayment = (data) => {
  return API.post(API_Account.payment.NON_PORTAL_PAYMENT, {
    IdUser,
    ...data,
  });
};

// -----------------------sms management-------------------
export const getListSmsManagement = () => {
  const data = {
    IdUser,
  };
  return API.post(API_Account.sms.GET_LIST_SMS_PANNEL, data);
};

export const changeStatusSmsList = (panel_id) => {
  const data = {
    panel_id,
    IdUser,
  };
  return API.post(API_Account.sms.ACTIVE_SMS_PANNEL, data);
};

export const getDetailSmsManagement = (panel_id) => {
  const data = {
    IdUser,
    panel_id,
  };
  return API.post(API_Account.sms.DETAIL_SMS_PANNEL, data);
};

export const updateSmsPanel = (formData) => {
  return API.post(API_Account.sms.UPDATE_SMS_PANNEL, formData);
};

export const deleteNotConfirmedOrderOnline = (data) => {
  return API.post("/UnitAccounting/DeleteOneOrderOnline", {
    IdUser,
    ...data,
  });
};
